module.exports = __webpack_public_path__ + "img/signatuur-inv-nl.acff0acf.svg";